import React from "react";

function SvgIcMapPoi077(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M15.909 16.991c.852-.129 1.677.651 1.842 1.743.166 1.092-.39 2.082-1.241 2.212-.852.129-1.677-.651-1.843-1.743-.166-1.092.39-2.083 1.242-2.212m-6.62 1.54a1.33 1.33 0 001.114-1.513l10.35-1.572c.11.725.787 1.224 1.512 1.114l.446 2.935a1.327 1.327 0 00-1.113 1.512L11.247 22.58v-.001a1.327 1.327 0 00-1.512-1.113l-.446-2.935zm14.283 4.376l-.133 1.059-3.74-.47 3.873-.59zm-.72-8.728l.099.65.745 4.908.072.47.21 1.387-1.856.282-11.117 1.689-1.644.249-.213.033-.282-1.857-.562-3.701v-.001l-.18-1.18-.102-.676 12.973-1.971.762-.116 1.095-.166zM8.56 14.034l3.741.47-3.874.59.133-1.06zm7.913-8.915l.107.067 7 5a1 1 0 01-1.054 1.696l-.109-.067L16 7.23l-6.419 4.585a1 1 0 01-1.26-1.55l.097-.079 7-5a.999.999 0 011.056-.067z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi077;
